module.exports = __webpack_public_path__ + "static/media/ADC2.7c6a7b01.svg";